import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { cancelOrder } from '@/data/api/request/orderDetailsRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useCancelOrder() {
  const queryClient = useQueryClient();

  const { isPending, error, mutate } = useMutation({
    mutationFn: (args: { orderId: string; reason: string }) =>
      cancelOrder(args.orderId, args.reason),
    onSuccess: (_data, args) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.detailOrder.details, args.orderId],
      });
      queryClient.invalidateQueries({ queryKey: [cacheKeys.detailOrder.list] });
    },
  });

  const { showSnackError } = useSnackbarContext();

  useEffect(() => {
    if (!error) return;
    showSnackError('Error al cancelar la orden');
  }, [error]);

  return { cancelOrder: mutate, cancelingOrder: isPending };
}
